export const EVENTS = {
	RECORDS_SELECTED: 'RECORDS_SELECTED',
	RECORD_SELECTED: 'RECORD_SELECTED'
};